import React from 'react';
import { SCHOOL_GRADE_SCALE_CONSTANT } from '../../../../constants/FrontEndConstant';
import { LANGUAGE_CODE } from '../../../../constants/DotEnv';
import Button from '@material-ui/core/Button';
class SurveyRatingWithSchoolGradeQuestion extends React.Component {
    
    labelOnClick = (e) => {
        if (e.currentTarget.name) {
            document.getElementById(e.currentTarget.name).click();
            document.getElementById(e.currentTarget.name).checked = !(document.getElementById(e.currentTarget.name).checked);
        }
    }

    render() {
        let data = this.props.questiondata;
        let survey_data = JSON.parse(localStorage.getItem("surveydetail_" + data.survey_id))
        let englishbuttonlabels;
        englishbuttonlabels = survey_data.englishbuttonlabels == "1" ? "EN" : "DE"
        let option = SCHOOL_GRADE_SCALE_CONSTANT[LANGUAGE_CODE].map((option, index) => {
            return (
            <button
                type="button"
                id={option.id}
                className={"MuiCustom-school-grade px-0 "+ ((this.props.questionanswer.free_text_answer === undefined) ?
                    (Object.keys(this.props.questionanswer).length === 0) ? "btn-grade box-shadow  school-grade-font rating-gray" : (this.props.counter[data.question_id] === option.title) ? 'btn-grade-clr school-grade-font box-shadow' : 'btn-grade school-grade-font rating-gray box-shadow'
                    : (this.props.questionanswer.free_text_answer === undefined) ? "btn-grade box-shadow school-grade-font rating-gray" : (this.props.questionanswer.free_text_answer === option.title) ? 'btn-grade-clr box-shadow school-grade-font' : 'btn-grade  school-grade-font rating-gray')
                }
                name={data.question_id}
                key={index}
                value={option.title}
                onClick={this.props.onSchoolGrade}
                style={survey_data.survey_color? {"--school-gradian": survey_data.survey_color} : {"--school-gradian": "#00b3f4"}}
            >
                <Button variant="contained" color="#00b3f4" className="" onClick={(e) => this.labelOnClick(e)}>
                    <span className="font-weight-bold h6 school-number rating-element-size">{option.id}</span><br />{SCHOOL_GRADE_SCALE_CONSTANT[englishbuttonlabels][index]["title"]}
                </Button>
            </button>)
        })
        return (<div key={this.props.questiondata.question_id} className={"tab-pane sectionstep custom-form-animated animated " + ((this.props.backButtonClick) ? "fadeInLeft" : "fadeInRight")} id="survey-form-1" data-step="0">
            <div className="text-center scool-grade">
                <div className="question-heading text-left">
                    <h3 className="text-dark font-weight-bold text-break survey-title">{data.question_text}</h3>
                    {(this.props.errormessage !== undefined) ? <div id="errorSurveyMessage" className="error-text"><p>{this.props.errormessage}</p></div> : null}
                </div>
                {option}
            </div>
        </div>);
    }
}
export default SurveyRatingWithSchoolGradeQuestion;